<template>
    <Vue3Marquee :pause-on-hover="true" :duration="40" class="d-flex align-items-center mb-2">
        <div
            v-for="order in orders"
            class="card me-2 mb-0"
        >
            <div class="card-body border-0 rounded-0 d-flex justify-content-between align-items-center p-2 bg-danger-light">
                {{ order?.handymans[0]?.name?.toUpperCase() }} is on leave on {{ formatDate(order.booking_date, 'DD MMM YYYY') }}, Please reassign {{ order.address.postal_code }} task. <button class="btn btn-sm btn-theme ms-2 rounded-1 pt-0 pb-0" @click="reassignOrder(order)">Update Order</button>
            </div>
        </div>
    </Vue3Marquee>
</template>
<script>
import moment from "moment";
import { Vue3Marquee } from 'vue3-marquee'

export default {
    components: {
        Vue3Marquee,
    },
    data() {
        return {
            orders: [],
        }
    },
    created() {
        this.getOrders();
    },
    mounted() {
        this.$emitter.on('getUnavailableHandymansOrdersEvent', (data) => {
            this.getOrders();
        })
    },
    methods: {
        getOrders() {
            let self = this;

            axios
                .post("/admin/orders/hm-leave-orders")
                .then((response) => {
                    self.orders = response.data.orders;
                });
        },
        formatDate(date, format) {
            return moment(date).format(format);
        },
        reassignOrder(order) {
            this.$emitter.emit('employeeLeaveEvent', {order: order});
        }
    }
}
</script>
